import React from 'react';
import { capitalCase } from 'change-case';
import { useBundle } from '@amzn/react-arb-tools';
import type {
  WorkOrderTask,
  WorkOrderTaskDefinition,
} from '@xbcb/api-gateway-client';
import { safeGet } from '@xbcb/js-utils';
import { safeGetMessage } from '@xbcb/ui-utils';
import { KatProgress, KatPopover } from '@amzn/katal-components/react';
import '@amzn/katal-components/es/progress';
import '@amzn/katal-components/es/popover';
import { StyledDiv, StyledParagraph } from './styles';

interface WorkOrderTaskInfoCardProps {
  loading?: boolean;
  workOrderTask: WorkOrderTask;
}

const WorkOrderTaskInfoCardKatal: React.FC<WorkOrderTaskInfoCardProps> = ({
  loading,
  workOrderTask,
}) => {
  const [taskInfoCardBundle] = useBundle('components.WorkOrderTaskInfoCard');
  const [taskStatusBundle] = useBundle(
    'types.workOrder.enums.WorkOrderTaskStatus',
  );
  const {
    assignee = {},
    definition = {} as WorkOrderTaskDefinition,
    name,
    status,
  } = workOrderTask || {};
  const { estimatedDuration = 15 } = definition;
  const currentAssignee = safeGet(
    assignee,
    'name',
    safeGetMessage(taskInfoCardBundle, 'nobody'),
  );

  return loading ? (
    <KatProgress indeterminate />
  ) : (
    <StyledDiv>
      <h3>{capitalCase(name || '')}</h3>
      <hr></hr>
      <KatPopover
        variant="tooltip"
        trigger-type="hover"
        position="right-end"
        kat-aria-behavior="tooltip"
      >
        <StyledParagraph slot="trigger">
          {safeGetMessage(taskInfoCardBundle, 'assigned_to', {
            assignee: currentAssignee,
          })}
        </StyledParagraph>
        {currentAssignee}
      </KatPopover>
      <StyledParagraph>
        {safeGetMessage(taskInfoCardBundle, 'status', {
          status: safeGetMessage(
            taskStatusBundle,
            status?.toLowerCase(),
            undefined,
            capitalCase(status || ''),
          ),
        })}
      </StyledParagraph>
      <StyledParagraph>
        {safeGetMessage(taskInfoCardBundle, 'estimated_duration', {
          estimatedDuration,
        })}
      </StyledParagraph>
    </StyledDiv>
  );
};

export default WorkOrderTaskInfoCardKatal;
